// extracted by mini-css-extract-plugin
module.exports = {"register":"Register_register__3Ry6Q","content":"Register_content__1r6HX","success":"Register_success__lVf5O","fadeIn":"Register_fadeIn__3Bdww","fadeOut":"Register_fadeOut__1ld58"};